import { useEffect, useRef, useState } from "react";
import { adminApi, ADMIN_TOKEN_KEY } from "@/lib/authApi";

export function useDashboardStream() {
  const [snap, setSnap] = useState(null);
  const [live, setLive] = useState("connecting");
  const [lastTs, setLastTs] = useState(null);
  const retry = useRef(1000);

  useEffect(() => {
    let es; let closed = false; let timer;
    const connect = () => {
      const token = localStorage.getItem(ADMIN_TOKEN_KEY);
      es = new EventSource(`${process.env.REACT_APP_BACKEND_URL}/api/admin/dashboard/stream?token=${encodeURIComponent(token || "")}`);
      const onFrame = (e) => {
        const f = JSON.parse(e.data);
        setLastTs(f.ts); setLive("live"); retry.current = 1000;
        if (f.type === "heartbeat") return;
        setSnap((prev) => ({ ...(prev || {}), ...Object.fromEntries(["kpis", "funnel", "tiers", "categories", "regions", "payments_today"].filter((k) => f[k] !== undefined).map((k) => [k, f[k]])) }));
      };
      es.addEventListener("snapshot", onFrame); es.addEventListener("delta", onFrame); es.addEventListener("heartbeat", onFrame);
      es.onerror = () => {
        es.close(); setLive("reconnecting");
        if (closed) return;
        timer = setTimeout(connect, retry.current); retry.current = Math.min(retry.current * 2, 30000);
        // fall back to a one-shot REST fetch so the page is never empty
        adminApi.get("/admin/dashboard/kpis").then((r) => setSnap((p) => ({ ...(p || {}), kpis: r.data }))).catch(() => {});
      };
    };
    connect();
    return () => { closed = true; clearTimeout(timer); es?.close(); };
  }, []);

  return { snap, live, lastTs };
}
